import React from 'react';
import PropTypes from 'prop-types';

const OpenLink = ({ className, height, onClick, width }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    height={height}
    onClick={onClick}
    width={width}
  >
    <path
      d="M16 3.414L9.707 9.707C9.512 9.902 9.256 10 9 10c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414L14.586 2H10c-.553 0-1-.447-1-1 0-.553.447-1 1-1h7c.553 0 1 .447 1 1v7c0 .553-.447 1-1 1-.553 0-1-.447-1-1V3.414zM3 18c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h2c.553 0 1 .447 1 1 0 .553-.447 1-1 1H3c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h12c.552 0 1-.448 1-1v-2c0-.553.447-1 1-1 .553 0 1 .447 1 1v2c0 1.654-1.346 3-3 3H3z"
      fill="#4BA0FF"
      fillRule="evenodd"
    />
  </svg>
);

OpenLink.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  onClick: PropTypes.func,
  width: PropTypes.number,
};

OpenLink.defaultProps = {
  height: 10,
  width: 10,
};

export default OpenLink;
